interface CardWithImageLeftProps {
  image: string;
  rightChildren: React.ReactNode;
  bgColourClass?: string;
  textClass?: string;
  rounded?: string;
  imageClass?: string; // Optional class for image styling
}

export default function CardWithImageLeft({
  image,
  rightChildren,
  bgColourClass = "bg-dark-beige group-hover:bg-dark-blue",
  textClass = "text-dark-grey group-hover:text-white",
  rounded = "6xl",
  imageClass
}: CardWithImageLeftProps) {
  return (
    <div className="flex flex-col sm:flex-row group">
      {/* > sm */}
      <div className="hidden sm:block w-2/5 h-auto">
        <img
          src={image}
          alt="An example"
          className={`
            h-full w-full object-cover
            rounded-l-${rounded}    /* left corners on larger screens */
            rounded-tr-none         /* remove top-right rounding in row layout */
            ${bgColourClass}
            ${imageClass || ""}     /* apply additional image styling if provided */
          `}
        />
      </div>
      <div
        className={`
          hidden sm:block w-3/5
          ${bgColourClass} ${textClass}
          p-8 text-left grid grid-cols-1 gap-y-4
          rounded-r-${rounded}         /* right corners on larger screens */
          rounded-bl-none              /* remove bottom-left rounding in row layout */
        `}
      >
        {rightChildren}
      </div>

      {/* < sm */}
      <div className="block sm:hidden w-full h-40">
        <img
          src={image}
          alt="An example"
          className={`
            h-full w-full object-cover
            rounded-t-${rounded}        /* top corners when stacked */
          `}
        />
      </div>
      <div
        className={`
          block sm:hidden w-full
          ${bgColourClass} ${textClass}
          p-8 text-left grid grid-cols-1 gap-y-4
          rounded-b-${rounded}            /* bottom corners when stacked */
        `}
      >
        {rightChildren}
      </div>
    </div>
  );
}
